var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "adam-header-bar",
        {
          class: [
            { "adam-header-bar--bg-dev": _vm.isDevEnvironment },
            { "adam-header-bar--bg-uat": _vm.isUatEnvironment }
          ],
          attrs: {
            "email-address": _vm.userProfile.email,
            "user-name": _vm.userProfile.name
          },
          domProps: { showNotifications: false },
          on: { "apps-click": _vm.clickDrawer }
        },
        [
          _c(
            "span",
            { attrs: { slot: "headerContent" }, slot: "headerContent" },
            [
              _c("img", {
                staticClass: "logo",
                attrs: {
                  src: require("../../public/logo/logo-coode-white.svg"),
                  alt: "Logo"
                }
              }),
              _c("span", { staticClass: "adam-header__separator" }),
              _vm._v(" " + _vm._s(_vm.appTitle) + " ")
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "right" }, slot: "right" },
            [
              _c("pui-form-select", {
                staticClass: "language-selector",
                attrs: {
                  options: _vm.languageOptions,
                  value: _vm.$i18n.locale,
                  "search-input-placeholder": _vm.$t("selectLanguage"),
                  label: ""
                },
                on: { change: _vm.changeLanguage }
              })
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "profileDetails" }, slot: "profileDetails" },
            [
              _c("adam-header-user-profile", {
                attrs: { user: _vm.userProfile }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "app-drawer",
        {
          ref: "appDrawer",
          domProps: {
            data: _vm.applications,
            labels: _vm.getAppDrawerLabels,
            onClick: _vm.handleAppClick
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "app-drawer-logo",
              attrs: { slot: "appLogo" },
              slot: "appLogo"
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../public/logo/logo-coode-rgb.svg"),
                  alt: "COODE logo"
                }
              })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }